/*
 * types/services/dr2am.tasks.permissions.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {PbPermissionRole} from './PbPermissionRole';
import {ProtobufFieldMask} from './ProtobufFieldMask';

/**
 * The ServiceUpdatePermissionRequest model module.
 * @module model/ServiceUpdatePermissionRequest
 * @version version not set
 */
export class ServiceUpdatePermissionRequest {
  /**
   * Constructs a new <code>ServiceUpdatePermissionRequest</code>.
   * @alias module:model/ServiceUpdatePermissionRequest
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceUpdatePermissionRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceUpdatePermissionRequest} obj Optional instance to populate.
   * @return {module:model/ServiceUpdatePermissionRequest} The populated <code>ServiceUpdatePermissionRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceUpdatePermissionRequest();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('permission'))
        obj.permission = PbPermissionRole.constructFromObject(data['permission']);
      if (data.hasOwnProperty('update_mask'))
        obj.updateMask = ProtobufFieldMask.constructFromObject(data['update_mask']);
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
ServiceUpdatePermissionRequest.prototype.id = undefined;

/**
 * @member {module:model/PbPermissionRole} permission
 */
ServiceUpdatePermissionRequest.prototype.permission = undefined;

/**
 * @member {module:model/ProtobufFieldMask} updateMask
 */
ServiceUpdatePermissionRequest.prototype.updateMask = undefined;


